export default __webpack_public_path__ + "static/media/frame_3.3ab04a12.png";